export default {"src":"/_next/static/media/challenge-checkmark-uncompleted.08ae4dff.svg","height":27,"width":32,"blurWidth":0,"blurHeight":0};